"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _ButtonLink = _interopRequireDefault(require("../../ButtonLink"));
var _Close = _interopRequireDefault(require("../../icons/Close"));
const ModalCloseButton = ({
  onClick,
  dataTest,
  title
}) => {
  return /*#__PURE__*/React.createElement(_ButtonLink.default, {
    onClick: onClick,
    size: "normal",
    iconLeft: /*#__PURE__*/React.createElement(_Close.default, null),
    dataTest: dataTest,
    type: "secondary",
    title: title
  });
};
var _default = exports.default = ModalCloseButton;